import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const adobeCommerce = defineConnector({
  identifier: "adobeCommerce",
  name: "Adobe Commerce",
  tagLine: "E-commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ storeDomain }) => domainToRegex(storeDomain),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Adobe Commerce API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Adobe Commerce API authentication docs](https://developer.adobe.com/commerce/webapi/get-started/authentication/gs-authentication-token/) and then sign in to your Adobe Commerce admin. Generate an integration token, and note the store domain and store code you want to use for API requests.",
        },
      ],
    },
    {
      title: "Connect your Adobe Commerce account",
      items: [
        {
          kind: "markdown",
          content:
            "Enter your Adobe Commerce instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Store Domain",
          placeholder: "yourstore.com",
          required: true,
          target: { kind: "configuration", field: "storeDomain" },
          helperText:
            "The domain of your Adobe Commerce store (e.g. https://yourstore.com)",
        },
        {
          kind: "input",
          label: "Store Code",
          placeholder: "default",
          required: true,
          target: { kind: "configuration", field: "storeCode" },
          helperText: "The store code for your Adobe Commerce store",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "3pgsytnpxbyz0waujkw9qllcjb79s379",
          helperText: "Your Adobe Commerce access token",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.storeDomain}/rest/${configuration.storeCode}/`,
  },
  publicEnvVars: ({ storeDomain, storeCode }) => ({
    ADOBE_COMMERCE_STORE_DOMAIN: storeDomain || "",
    ADOBE_COMMERCE_STORE_CODE: storeCode || "",
  }),
});
